import { initCharts } from './charts'
import initRates from './rates'
import initAlertModal from 'components/alert-modal'
import marketService from 'services/market'
import initVanillaSelect from 'components/select-vanilla'

init()

function init(): void {
  marketService.fetchRates()
  setInterval(marketService.fetchRates, 10 * 1000)

  initRates()
  initVanillaSelect()
  initAlertModal()
  initCharts()
}
